import React, { useEffect, useState } from "react";
import {
  Row, Col, Card, CardBody, Input, Label, Button, Form, Alert
} from "reactstrap";
import { post, get, put } from "../../helpers/api_helper";
import {
  ADD_ADDRESS, CITIES_SEARCH, DISTRICTS_SEARCH, SUBDISTRICTS_SEARCH,
  COUNTRIES_SEARCH, SHOW_ADDRESS, GOOGLE_LOCATION, UPDATE_ADDRESS, ADD_DISTRICT
} from "helpers/api_endpoints";
import Select from "react-select";
import { Trans } from "react-i18next";
import MapComponent from "./MapSelect"
import MapBComponent from "./Map"

const AddressForm = ({ addressId = "", onSuccess, onCancel, mode, showMap = false, express, showBoundries = false, showControls = true
  , showDets = true, phoneRequired = false }) => {
  const [type, setType] = useState(1);
  const [status, setStatus] = useState(1);
  const [url, setUrl] = useState(null);
  const [street, setStreet] = useState(null);
  const [phone, setPhone] = useState(null);
  const [title, setTitle] = useState(null);
  const [countryId, setCountryId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [subDistrictId, setSubDistrictId] = useState(null);
  const [building, setBuilding] = useState('');
  const [flatNo, setFlatNo] = useState('');
  const [longitude, setLongitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [boundries, setBoundries] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [countries, setCountries] = useState([]);
  const [marker, setMarker] = useState({lat:0, lng:0});
  const [change, setChange] = useState(0);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (addressId && addressId != '') {
      get(SHOW_ADDRESS + '/' + addressId)
        .then(response => {
          const data = response.data;
          setTitle(data.title);
          setCountryId(data.countryId);
          setTimeout(() => {
            setCityId(data.cityId);
            setDistrictId(data.districtId);
            // console.log('data.districtId', districts, data.districtId, districts.find(d => d.value === data.districtId)) 
            setSubDistrictId(data.subDistrictId);
          }, 1200);
            setDistrictId(data.districtId);
          setBuilding(data.building);
          setFlatNo(data.flatNo);
          setPhone(data.phone);
          setBoundries(data.boundries);
          setLatitude(Number(data.latitude));
          setLongitude(Number(data.longitude));
          setMarker({lat:Number(data.latitude), lng:Number(data.longitude)});
        })
        .catch(() => setErrorMsg("Failed to load address"));
    }
  }, [addressId]);

  useEffect(() => {
    post(DISTRICTS_SEARCH).then(res =>
      setDistricts(res.data.map(el => ({ value: el.id, label: el.name, cityId: el.cityId })))
    );
    post(COUNTRIES_SEARCH).then(res =>
      setCountries(res.data.map(el => ({ value: el.id, label: el.name })))
    );
    post(CITIES_SEARCH).then(res =>
      setCities(res.data.map(el => ({ value: el.id, label: el.name, countryId: el.countryId })))
    );
    post(SUBDISTRICTS_SEARCH).then(res =>
      setSubDistricts(res.data.map(el => ({ value: el.id, label: el.name, districtId: el.districtId })))
    );
  }, []);

  useEffect(() => {
    setLatitude(Number(marker.lat));
    setLongitude(Number(marker.lng));
  }, [marker]);

  useEffect(() => {
    const city = cities.filter(c => !countryId || c.countryId === countryId)[0];
    setCityId(city ? city.value : null);
    const district = districts.filter(c => !cityId || c.cityId === cityId)[0];
    setDistrictId(district ? district.value : null);
    const subDistrict = subDistricts.filter(c => !districtId || c.districtId === districtId)[0];
    setSubDistrictId(subDistrict ? subDistrict.value : null);
  }, [countryId]);

  useEffect(() => {
    console.log('cityId', cityId);
    setDistrictId(null);
    setSubDistrictId(null);
  }, [cityId]);

  useEffect(() => {
    const subDistrict = subDistricts.filter(c => !districtId || c.districtId === districtId)[0];
    setSubDistrictId(subDistrict ? subDistrict.value : null);
  }, [districtId]);

  const handleSubmit = async () => {
    const payload = {
      type, status, street, phone, title:title?title:'New', countryId, cityId,
      districtId, subDistrictId, building, flatNo, longitude, latitude, boundries
    };
    if(!districtId && boundries?.length>0 && countryId && cityId)
    {
      const district = await post(ADD_DISTRICT, { name:'{"title":[{"1":"New"},{"2":""}]}', cityId, symbol:'DISTRICT', status:1, boundries });
      payload.districtId = district.data.id;
    }
    const request =  post(ADD_ADDRESS, payload);
    request
      .then(response => {
        if (( response.code === 200 || response.code === 201) && onSuccess) onSuccess(response.data);
      })
      .catch((err) => {console.log('err', err);setErrorMsg('Failed to save address')});
  };
  
  const getGoogleLocation = () => {
    post(GOOGLE_LOCATION, { url: url }).then(response => {
      if (response.code === 200) {
        const u = response.data.url;
        let data = '';
        let location = '';
        if(u.indexOf('?utm') > -1)
        {
          data = u.split('?utm')[0].split('!');
          const lat = data[data.length - 2].substring(2);
          const lng = data[data.length - 1].substring(2);
          location  = [lat, lng];
        }
        else if(u.indexOf('@') > -1)
        {
          data = u.split('@')[1].split(',');
          location  = data;
        }
        else if(u.indexOf('q=') > -1)
        {
          data = u.split('q=')[1].split('&')[0].split(',');
          location  = data;
        }
        else if(u.indexOf('?') > -1)
        {
          data = u.split('?')[0].split('/');
          location  = data[data.length - 1].split(',+');
        }
        setMarker({lat:Number(location[0]), lng:Number(location[1])});
        setChange(change++);
        setErrorMsg('');
      }
    }).catch(() => setErrorMsg(''));
    
  }

    return (
    <Form onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
      <Card>
        <CardBody>
          <Row>
            {errorMsg && <Alert color="danger">{errorMsg}</Alert>}

                  {showDets?(
                    <div className="form-group col-md-12 mt-2">
                      <Row>
                      {
                        mode==1?(
                        <div className="form-group col-md-6 mt-2">
                          <Label><Trans>Google locarion</Trans></Label>
                          <Input value={url} onChange={e => setUrl(e.target.value)}  />
                          <button type="button" className="btn btn-primary mt-2" onClick={getGoogleLocation}>
                            Get
                          </button>
                        </div>
                      ):<></>}

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Title (This will appear for the driver)</Trans></Label>
                        <Input value={title} onChange={e => setTitle(e.target.value)} required={!express} />
                      </div>

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Country</Trans></Label>
                        <Select
                          value={countries.find(c => c.value === countryId)}
                          options={countries}
                          onChange={e => setCountryId(e.value)}
                          required={!express}
                        />
                      </div>

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>City</Trans></Label>
                        <Select
                          value={cities.find(c => c.value === cityId)}
                          options={cities.filter(c => !countryId || c.countryId === countryId)}
                          onChange={e => setCityId(e.value)}
                          required={!express}
                        />
                      </div>

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>District</Trans></Label>
                        <Select
                          value={districts.find(d => d.value === districtId)}
                          options={districts.filter(d => !cityId || d.cityId === cityId)}
                          onChange={e => setDistrictId(e.value)}
                          required={!express}
                        />
                      </div>

                      {
                        mode==1?(
                        <div className="form-group col-md-6 mt-2">
                          <Label><Trans>Sub District</Trans></Label>
                          <Select
                            value={subDistricts.find(s => s.value === subDistrictId)}
                            options={subDistricts.filter(s => !districtId || s.districtId === districtId)}
                            onChange={e => setSubDistrictId(e.value)}
                            
                          />
                        </div>
                      ):<></>}
                      </Row>
                    </div>
                  ):<></>}
            {
              mode==1?(
                <div className="form-group col-md-12 mt-2">
                  <Row>
                  {showDets?(
                    <div className="form-group col-md-12 mt-2">
                      <Row>
                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Street</Trans></Label>
                        <Input value={street} onChange={e => setStreet(e.target.value)} required={!express} />
                      </div>

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Building</Trans></Label>
                        <Input value={building} onChange={e => setBuilding(e.target.value)} required={!express} />
                      </div>

                      {showMap?(
                        <div className="form-group col-md-12 mt-2">
                          <Row>
                          <div className="form-group col-md-6 mt-2">
                            <Label><Trans>Flat No</Trans></Label>
                            <Input value={flatNo} onChange={e => setFlatNo(e.target.value)} required={!express} />
                          </div>

                          <div className="form-group col-md-6 mt-2" style={phoneRequired?{backgroundColor:'pink'}:{}}>
                            <Label><Trans>Phone</Trans></Label>
                            <Input value={phone} onChange={e => setPhone(e.target.value)} required={!express || phoneRequired} />
                          </div> 
                          </Row>
                        </div>
                      ):<></>}

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Latitude</Trans></Label>
                        <Input value={latitude} onChange={e => setLatitude(e.target.value)} required />
                      </div>

                      <div className="form-group col-md-6 mt-2">
                        <Label><Trans>Longitude</Trans></Label>
                        <Input value={longitude} onChange={e => setLongitude(e.target.value)} required />
                      </div>
                      </Row>
                    </div>
                  ):<></>}
                    {showMap?(
                        <div className="form-group col-md-12 mt-2">
                            <Label className="form-label"><Trans>Location</Trans></Label>
                            <MapComponent key={change} marker={marker} setMarker={setMarker} />
                        </div>

                    ):<></>}
                    {showBoundries?(
                        <div className="form-group col-md-12 mt-2">
                            <Label className="form-label"><Trans>Location</Trans></Label>
                            <MapBComponent key={change} boundries={boundries} setBoundries={setBoundries} />
                        </div>

                    ):<></>}
                    </Row>
                </div>
              )
            :(<></>)}
          </Row>
          {showControls? (
            <div className="text-end mt-4">
              <Button type="submit" color="primary">
                <Trans>Save</Trans>
              </Button>{" "}
              {onCancel && (
                <Button type="button" color="secondary" onClick={onCancel}>
                  <Trans>Cancel</Trans>
                </Button>
              )}
            </div>

          ):<></>}
        </CardBody>
      </Card>
    </Form>
  );
};

export default AddressForm;
